const ELEMENT_VISIBILITY_GROUPS = [
    {
        group: 'Unit',
        items: [
            { key: 'unit_group_standards', label: 'Unit Standards' },
            { key: 'unit_group_panels', label: 'Panels' },
            { key: 'unit_group_trunk_pedigree', label: 'Trunk Unit Pedigree' },
            { key: 'unit_group_assessment_questions', label: 'Unit Assessment (questions)' },
            { key: 'unit_group_assessment_pdf', label: 'Unit Assessment PDF' },
            { key: 'unit_group_printables', label: 'Unit Printables' },
            { key: 'unit_group_weekly_issues_list', label: 'Weekly/Lesson Issues (this filter will hide all weekly and article content)' },
        ],
    },
    {
        group: 'Week/Lesson',
        items: [
            { key: 'unit_week_standards', label: 'Week Standards' },
            { key: 'unit_trunk_pedigree_week', label: 'Trunk Pedigree (Week)' },
            { key: 'unit_panels', label: 'Panels' },
            { key: 'unit_crossword', label: 'Crossword' },
            { key: 'unit_weekly_vocabulary', label: 'Weekly/Lesson Vocabulary' },
            { key: 'unit_weekly_assessment_questions', label: 'Weekly/Lesson Assessment (questions)' },
            { key: 'unit_weekly_printables', label: 'Weekly/Lesson Printables' },
            { key: 'unit_weekly_teacher_edition', label: 'Weekly/Lesson Teacher Edition' },
            { key: 'unit_flipbooks', label: 'Flip Books' },
            { key: 'unit_weekly_assessment_pdf', label: 'Weekly/Lesson Assessment PDF' },
            { key: 'unit_educator_guide_for_ca', label: 'Educator Guide for Lesson (CA)' },
            { key: 'unit_eld_standards_ca', label: 'ELD Standards (CA)' },
            { key: 'unit_student_edition', label: 'Student Edition' },
            { key: 'unit_bibliography', label: 'Bibliography' },
            { key: 'unit_linked_articles', label: 'Linked Articles' },
            { key: 'unit_articles', label: 'Articles (this filter will hide all article content)' },
        ],
    },
    {
        group: 'Article',
        items: [
            { key: 'article_body', label: 'Article Body' },
            { key: 'article_activity_layout', label: 'Activity/Assessment Layout' },
            { key: 'article_assessment_pdf', label: 'Assessment PDF' },
            { key: 'article_walkthrough', label: 'Walkthrough' },
            { key: 'article_rubric_items', label: 'Rubric Items' },
            { key: 'article_designer_notes', label: 'Designer Notes' },
            { key: 'article_activity_answer_key', label: 'Activity Answer Key' },
            { key: 'article_narration', label: 'Narration' },
            { key: 'article_panels', label: 'Article Panels' },
            { key: 'article_vocabulary', label: 'Vocabulary' },
            { key: 'article_questions', label: 'Article Questions' },
            { key: 'article_materials_calculator', label: 'Materials Calculator' },
            { key: 'article_plan', label: 'Lesson Plan' },
            { key: 'article_printables', label: 'Article Printables' },
            { key: 'article_related_media', label: 'Related Media' },
            { key: 'article_citations', label: 'Citations' },
            { key: 'article_tags', label: 'Tags' },
            { key: 'article_pedigree', label: 'Pedigree' },
        ],
    },
]

const ELEMENT_VISIBILITY_DEFAULTS = (() => {
    const defaults = {}
    for (const group of ELEMENT_VISIBILITY_GROUPS) {
        for (const item of group.items) {
            defaults[item.key] = true
        }
    }
    return Object.freeze(defaults)
})()

const getElementVisibilityDefaults = () => ({ ...ELEMENT_VISIBILITY_DEFAULTS })

const isElementVisible = (map, key) => {
    if (!map) {
        return true
    }
    if (Object.prototype.hasOwnProperty.call(map, key)) {
        return map[key]
    }
    return true
}

export {
    ELEMENT_VISIBILITY_GROUPS,
    ELEMENT_VISIBILITY_DEFAULTS,
    getElementVisibilityDefaults,
    isElementVisible,
}
